@if (isBuckaroo && transaction && transaction.transactionId) {
  <div id="buckarooContainer" class="mt-5 text-center">
    <h4 *appApplyIfNotEmpty="translationService.getTranslation('buckaroo.transaction.created')"
        [innerHTML]="translationService.getTranslation('buckaroo.transaction.created')"></h4>
    <div (click)="goToBuckaroo()" id="idealButton">
      <img alt="IDEAL Logo" src="assets/images/IDEAL_logo.svg">
    </div>
  </div>
}

@if (isPaypal) {
  <div #paypalButtonContainer id="paypal-button-container" class="col-xl-6 offset-xl-3"></div>
}
